import React, { useMemo } from 'react';
import { useCountries } from '../queries';

interface Props {
  countryKey?: string;
}

export const Country = ({ countryKey }: Props) => {
  const { data: countries } = useCountries();
  const country = useMemo(() => {
    if (!countries) {
      return null;
    }
    return countries.find(c => {
      return c.key === countryKey;
    });
  }, [countries, countryKey]);
  return <div>{country ? country.name : null}</div>;
};
